import { render } from "./BookHousesSatistics.vue?vue&type=template&id=131d03ee&scoped=true"
import script from "./BookHousesSatistics.vue?vue&type=script&lang=js"
export * from "./BookHousesSatistics.vue?vue&type=script&lang=js"

import "./BookHousesSatistics.vue?vue&type=style&index=0&id=131d03ee&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131d03ee"]])

export default __exports__